var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path, _g1, _rect, _g10, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicDeveloperDesigner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 829,
    height: 266,
    viewBox: "0 0 829 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 216.754L225.853 220.289L244.46 220.289L244.46 216.754L225.853 216.754Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 213.219L225.853 216.754L244.46 216.754L244.46 213.219L225.853 213.219Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 209.684L225.853 213.219L244.46 213.219L244.46 209.684L225.853 209.684Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 206.15L225.853 209.685L244.46 209.685L244.46 206.15L225.853 206.15Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 202.615L225.853 206.15L244.46 206.15L244.46 202.615L225.853 202.615Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 199.08L225.853 202.615L244.46 202.615L244.46 199.08L225.853 199.08Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 195.545L225.853 199.08L244.46 199.08L244.46 195.545L225.853 195.545Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 216.088L225.853 218.086L238.258 218.086L238.258 216.088L225.853 216.088Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 211.887L225.853 213.885L238.258 213.885L238.258 211.887L225.853 211.887Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 205.65L225.853 207.648L238.258 207.648L238.258 205.65L225.853 205.65Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 201.654L225.853 203.652L238.258 203.652L238.258 201.654L225.853 201.654Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 197.581L225.853 199.579L238.258 199.579L238.258 197.581L225.853 197.581Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 192.01L225.853 195.545L244.46 195.545L244.46 192.01L225.853 192.01Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 188.475L225.853 192.01L244.46 192.01L244.46 188.475L225.853 188.475Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 184.94L225.853 188.475L244.46 188.475L244.46 184.94L225.853 184.94Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 181.406L225.853 184.941L244.46 184.941L244.46 181.406L225.853 181.406Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 177.871L225.853 181.406L244.46 181.406L244.46 177.871L225.853 177.871Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 174.336L225.853 177.871L244.46 177.871L244.46 174.336L225.853 174.336Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 170.801L225.853 174.336L244.46 174.336L244.46 170.801L225.853 170.801Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 191.344L225.853 193.342L238.258 193.342L238.258 191.344L225.853 191.344Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 187.143L225.853 189.141L238.258 189.141L238.258 187.143L225.853 187.143Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 180.906L225.853 182.904L238.258 182.904L238.258 180.906L225.853 180.906Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 176.91L225.853 178.908L238.258 178.908L238.258 176.91L225.853 176.91Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 172.837L225.853 174.835L238.258 174.835L238.258 172.837L225.853 172.837Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 167.266L225.853 170.801L244.46 170.801L244.46 167.266L225.853 167.266Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 163.731L225.853 167.266L244.46 167.266L244.46 163.731L225.853 163.731Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 160.196L225.853 163.731L244.46 163.731L244.46 160.196L225.853 160.196Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 156.662L225.853 160.197L244.46 160.197L244.46 156.662L225.853 156.662Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 153.127L225.853 156.662L244.46 156.662L244.46 153.127L225.853 153.127Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 149.592L225.853 153.127L244.46 153.127L244.46 149.592L225.853 149.592Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 146.057L225.853 149.592L244.46 149.592L244.46 146.057L225.853 146.057Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 166.6L225.853 168.598L238.258 168.598L238.258 166.6L225.853 166.6Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 162.399L225.853 164.397L238.258 164.397L238.258 162.399L225.853 162.399Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 156.162L225.853 158.16L238.258 158.16L238.258 156.162L225.853 156.162Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 152.166L225.853 154.164L238.258 154.164L238.258 152.166L225.853 152.166Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 148.093L225.853 150.091L238.258 150.091L238.258 148.093L225.853 148.093Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 117.778L225.853 121.313L244.46 121.313L244.46 117.778L225.853 117.778Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 114.243L225.853 117.778L244.46 117.778L244.46 114.243L225.853 114.243Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 110.708L225.853 114.243L244.46 114.243L244.46 110.708L225.853 110.708Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 107.174L225.853 110.708L244.46 110.708L244.46 107.174L225.853 107.174Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 103.639L225.853 107.174L244.46 107.174L244.46 103.639L225.853 103.639Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 100.104L225.853 103.639L244.46 103.639L244.46 100.104L225.853 100.104Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 96.5689L225.853 100.104L244.46 100.104L244.46 96.5689L225.853 96.5689Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 117.112L225.853 119.11L238.258 119.11L238.258 117.112L225.853 117.112Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 112.911L225.853 114.909L238.258 114.909L238.258 112.911L225.853 112.911Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 106.674L225.853 108.672L238.258 108.672L238.258 106.674L225.853 106.674Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 102.678L225.853 104.676L238.258 104.676L238.258 102.678L225.853 102.678Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 98.6053L225.853 100.603L238.258 100.603L238.258 98.6053L225.853 98.6053Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 68.2901L225.853 71.825L244.46 71.8249L244.46 68.2901L225.853 68.2901Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 64.7552L225.853 68.29L244.46 68.29L244.46 64.7552L225.853 64.7552Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 61.2203L225.853 64.7551L244.46 64.7551L244.46 61.2203L225.853 61.2203Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 57.6856L225.853 61.2205L244.46 61.2204L244.46 57.6856L225.853 57.6856Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 54.1507L225.853 57.6855L244.46 57.6855L244.46 54.1507L225.853 54.1507Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 50.6158L225.853 54.1506L244.46 54.1506L244.46 50.6158L225.853 50.6158Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 67.6241L225.853 69.6221L238.258 69.6221L238.258 67.6241L225.853 67.6241Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 63.4232L225.853 65.4211L238.258 65.4211L238.258 63.4232L225.853 63.4232Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 57.1861L225.853 59.1841L238.258 59.1841L238.258 57.1861L225.853 57.1861Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 53.19L225.853 55.188L238.258 55.188L238.258 53.19L225.853 53.19Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 142.522L225.853 146.057L244.46 146.057L244.46 142.522L225.853 142.522Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 138.987L225.853 142.522L244.46 142.522L244.46 138.987L225.853 138.987Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 135.452L225.853 138.987L244.46 138.987L244.46 135.452L225.853 135.452Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 131.918L225.853 135.453L244.46 135.453L244.46 131.918L225.853 131.918Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 128.383L225.853 131.918L244.46 131.918L244.46 128.383L225.853 128.383Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 124.848L225.853 128.383L244.46 128.383L244.46 124.848L225.853 124.848Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 121.313L225.853 124.848L244.46 124.848L244.46 121.313L225.853 121.313Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 141.856L225.853 143.854L238.258 143.854L238.258 141.856L225.853 141.856Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 137.655L225.853 139.653L238.258 139.653L238.258 137.655L225.853 137.655Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 131.418L225.853 133.416L238.258 133.416L238.258 131.418L225.853 131.418Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 127.422L225.853 129.42L238.258 129.42L238.258 127.422L225.853 127.422Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 123.349L225.853 125.347L238.258 125.347L238.258 123.349L225.853 123.349Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.853 93.0342L225.853 96.5691L244.46 96.5691L244.46 93.0342L225.853 93.0342Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 89.4993L225.853 93.0342L244.46 93.0342L244.46 89.4993L225.853 89.4993Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 85.9644L225.853 89.4993L244.46 89.4993L244.46 85.9644L225.853 85.9644Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 82.4297L225.853 85.9646L244.46 85.9646L244.46 82.4297L225.853 82.4297Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 78.8948L225.853 82.4297L244.46 82.4297L244.46 78.8948L225.853 78.8948Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 75.3599L225.853 78.8948L244.46 78.8948L244.46 75.3599L225.853 75.3599Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 71.825L225.853 75.3599L244.46 75.3598L244.46 71.825L225.853 71.825Z",
    fill: "white",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 92.3682L225.853 94.3662L238.258 94.3662L238.258 92.3682L225.853 92.3682Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 88.1673L225.853 90.1653L238.258 90.1653L238.258 88.1673L225.853 88.1673Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 81.9303L225.853 83.9282L238.258 83.9282L238.258 81.9303L225.853 81.9303Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 77.9342L225.853 79.9321L238.258 79.9321L238.258 77.9342L225.853 77.9342Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.853 73.8614L225.853 75.8594L238.258 75.8594L238.258 73.8614L225.853 73.8614Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 0.1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 0.999603,
    transform: "matrix(-7.30595e-06 -1 1 -8.09664e-07 244.874 223)",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.392,
    y: 220.405,
    width: 163.805,
    height: 2.69871,
    transform: "rotate(-90 224.392 220.405)",
    fill: "#FF4D5A"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 224.72,
    y: 226.551,
    width: 6.20575,
    height: 22.2255,
    transform: "rotate(-90 224.72 226.551)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.72,
    y: 56.1526,
    width: 6.20575,
    height: 22.2255,
    transform: "rotate(-90 224.72 56.1526)",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5793 231.205L223.675 231.205L224.768 231.205L224.768 44.0352C212.17 44.399 182.343 44.9083 163.818 44.0352C140.661 42.9438 123.622 67.2814 107.019 83.5428C93.7364 96.552 61.6521 103.733 47.2703 105.698C32.5243 107.844 3.22907 123.858 4.01552 170.743C4.80197 217.629 42.7191 230.587 61.5793 231.205Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5685 191.2V215H81.1545V195.96L71.8045 211.974H70.6145L61.2645 196.062V215H58.8505V191.2H60.9245L71.2605 208.846L81.4945 191.2H83.5685ZM106.929 197.116V215H104.617V211.736C103.983 212.824 103.11 213.674 101.999 214.286C100.889 214.875 99.6192 215.17 98.1912 215.17C95.8565 215.17 94.0092 214.524 92.6492 213.232C91.3119 211.917 90.6432 210.002 90.6432 207.486V197.116H93.0572V207.248C93.0572 209.129 93.5219 210.557 94.4512 211.532C95.3805 212.506 96.7065 212.994 98.4292 212.994C100.311 212.994 101.795 212.427 102.883 211.294C103.971 210.138 104.515 208.54 104.515 206.5V197.116H106.929ZM118.484 215.17C117.033 215.17 115.639 214.966 114.302 214.558C112.987 214.127 111.956 213.594 111.208 212.96L112.296 211.056C113.044 211.645 113.985 212.132 115.118 212.518C116.251 212.88 117.43 213.062 118.654 213.062C120.286 213.062 121.487 212.812 122.258 212.314C123.051 211.792 123.448 211.067 123.448 210.138C123.448 209.48 123.233 208.97 122.802 208.608C122.371 208.222 121.827 207.939 121.17 207.758C120.513 207.554 119.64 207.361 118.552 207.18C117.101 206.908 115.934 206.636 115.05 206.364C114.166 206.069 113.407 205.582 112.772 204.902C112.16 204.222 111.854 203.281 111.854 202.08C111.854 200.584 112.477 199.36 113.724 198.408C114.971 197.456 116.705 196.98 118.926 196.98C120.082 196.98 121.238 197.138 122.394 197.456C123.55 197.75 124.502 198.147 125.25 198.646L124.196 200.584C122.723 199.564 120.966 199.054 118.926 199.054C117.385 199.054 116.217 199.326 115.424 199.87C114.653 200.414 114.268 201.128 114.268 202.012C114.268 202.692 114.483 203.236 114.914 203.644C115.367 204.052 115.923 204.358 116.58 204.562C117.237 204.743 118.144 204.936 119.3 205.14C120.728 205.412 121.873 205.684 122.734 205.956C123.595 206.228 124.332 206.692 124.944 207.35C125.556 208.007 125.862 208.914 125.862 210.07C125.862 211.634 125.205 212.88 123.89 213.81C122.598 214.716 120.796 215.17 118.484 215.17ZM130.325 197.116H132.739V215H130.325V197.116ZM131.549 193.206C131.05 193.206 130.631 193.036 130.291 192.696C129.951 192.356 129.781 191.948 129.781 191.472C129.781 191.018 129.951 190.622 130.291 190.282C130.631 189.942 131.05 189.772 131.549 189.772C132.048 189.772 132.467 189.942 132.807 190.282C133.147 190.599 133.317 190.984 133.317 191.438C133.317 191.936 133.147 192.356 132.807 192.696C132.467 193.036 132.048 193.206 131.549 193.206ZM146.868 215.17C145.1 215.17 143.513 214.784 142.108 214.014C140.725 213.243 139.637 212.166 138.844 210.784C138.05 209.378 137.654 207.803 137.654 206.058C137.654 204.312 138.05 202.748 138.844 201.366C139.637 199.983 140.725 198.906 142.108 198.136C143.513 197.365 145.1 196.98 146.868 196.98C148.409 196.98 149.78 197.286 150.982 197.898C152.206 198.487 153.169 199.36 153.872 200.516L152.07 201.74C151.48 200.856 150.732 200.198 149.826 199.768C148.919 199.314 147.933 199.088 146.868 199.088C145.576 199.088 144.408 199.382 143.366 199.972C142.346 200.538 141.541 201.354 140.952 202.42C140.385 203.485 140.102 204.698 140.102 206.058C140.102 207.44 140.385 208.664 140.952 209.73C141.541 210.772 142.346 211.588 143.366 212.178C144.408 212.744 145.576 213.028 146.868 213.028C147.933 213.028 148.919 212.812 149.826 212.382C150.732 211.951 151.48 211.294 152.07 210.41L153.872 211.634C153.169 212.79 152.206 213.674 150.982 214.286C149.758 214.875 148.386 215.17 146.868 215.17ZM158.614 197.116H161.028V215H158.614V197.116ZM159.838 193.206C159.339 193.206 158.92 193.036 158.58 192.696C158.24 192.356 158.07 191.948 158.07 191.472C158.07 191.018 158.24 190.622 158.58 190.282C158.92 189.942 159.339 189.772 159.838 189.772C160.337 189.772 160.756 189.942 161.096 190.282C161.436 190.599 161.606 190.984 161.606 191.438C161.606 191.936 161.436 192.356 161.096 192.696C160.756 193.036 160.337 193.206 159.838 193.206ZM174.001 196.98C176.336 196.98 178.126 197.569 179.373 198.748C180.62 199.904 181.243 201.626 181.243 203.916V215H178.931V212.212C178.387 213.141 177.582 213.866 176.517 214.388C175.474 214.909 174.228 215.17 172.777 215.17C170.782 215.17 169.196 214.694 168.017 213.742C166.838 212.79 166.249 211.532 166.249 209.968C166.249 208.449 166.793 207.225 167.881 206.296C168.992 205.366 170.748 204.902 173.151 204.902H178.829V203.814C178.829 202.272 178.398 201.105 177.537 200.312C176.676 199.496 175.418 199.088 173.763 199.088C172.63 199.088 171.542 199.28 170.499 199.666C169.456 200.028 168.561 200.538 167.813 201.196L166.725 199.394C167.632 198.623 168.72 198.034 169.989 197.626C171.258 197.195 172.596 196.98 174.001 196.98ZM173.151 213.266C174.511 213.266 175.678 212.96 176.653 212.348C177.628 211.713 178.353 210.806 178.829 209.628V206.704H173.219C170.159 206.704 168.629 207.769 168.629 209.9C168.629 210.942 169.026 211.77 169.819 212.382C170.612 212.971 171.723 213.266 173.151 213.266ZM196.912 196.98C199.156 196.98 200.935 197.637 202.25 198.952C203.587 200.244 204.256 202.136 204.256 204.63V215H201.842V204.868C201.842 203.009 201.377 201.592 200.448 200.618C199.518 199.643 198.192 199.156 196.47 199.156C194.543 199.156 193.013 199.734 191.88 200.89C190.769 202.023 190.214 203.598 190.214 205.616V215H187.8V197.116H190.112V200.414C190.769 199.326 191.676 198.487 192.832 197.898C194.01 197.286 195.37 196.98 196.912 196.98Z",
    fill: "#222222"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.335 85L360.815 133.673L416.335 181.5V171L372.698 133.673L416.335 95.5V85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.759 85L523.28 133.673L467.759 181.5V171L511.397 133.673L467.759 95.5V85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.463 192.6H373.583C375.951 192.6 378.042 193.08 379.855 194.04C381.669 194.979 383.077 196.301 384.079 198.008C385.082 199.693 385.583 201.624 385.583 203.8C385.583 205.976 385.082 207.917 384.079 209.624C383.077 211.309 381.669 212.632 379.855 213.592C378.042 214.531 375.951 215 373.583 215H364.463V192.6ZM373.455 212.952C375.418 212.952 377.135 212.568 378.607 211.8C380.079 211.011 381.221 209.933 382.031 208.568C382.842 207.181 383.247 205.592 383.247 203.8C383.247 202.008 382.842 200.429 382.031 199.064C381.221 197.677 380.079 196.6 378.607 195.832C377.135 195.043 375.418 194.648 373.455 194.648H366.831V212.952H373.455ZM405.077 207.288H390.997C391.125 209.037 391.797 210.456 393.013 211.544C394.229 212.611 395.765 213.144 397.621 213.144C398.666 213.144 399.626 212.963 400.501 212.6C401.375 212.216 402.133 211.661 402.773 210.936L404.053 212.408C403.306 213.304 402.367 213.987 401.237 214.456C400.127 214.925 398.901 215.16 397.557 215.16C395.829 215.16 394.293 214.797 392.949 214.072C391.626 213.325 390.591 212.301 389.845 211C389.098 209.699 388.725 208.227 388.725 206.584C388.725 204.941 389.077 203.469 389.781 202.168C390.506 200.867 391.487 199.853 392.725 199.128C393.983 198.403 395.391 198.04 396.949 198.04C398.506 198.04 399.903 198.403 401.141 199.128C402.378 199.853 403.349 200.867 404.053 202.168C404.757 203.448 405.109 204.92 405.109 206.584L405.077 207.288ZM396.949 199.992C395.327 199.992 393.962 200.515 392.853 201.56C391.765 202.584 391.146 203.928 390.997 205.592H402.933C402.783 203.928 402.154 202.584 401.045 201.56C399.957 200.515 398.591 199.992 396.949 199.992ZM423.565 198.168L416.077 215H413.741L406.285 198.168H408.653L414.957 212.504L421.325 198.168H423.565ZM440.952 207.288H426.872C427 209.037 427.672 210.456 428.888 211.544C430.104 212.611 431.64 213.144 433.496 213.144C434.541 213.144 435.501 212.963 436.376 212.6C437.25 212.216 438.008 211.661 438.648 210.936L439.928 212.408C439.181 213.304 438.242 213.987 437.112 214.456C436.002 214.925 434.776 215.16 433.432 215.16C431.704 215.16 430.168 214.797 428.824 214.072C427.501 213.325 426.466 212.301 425.72 211C424.973 209.699 424.6 208.227 424.6 206.584C424.6 204.941 424.952 203.469 425.656 202.168C426.381 200.867 427.362 199.853 428.6 199.128C429.858 198.403 431.266 198.04 432.824 198.04C434.381 198.04 435.778 198.403 437.016 199.128C438.253 199.853 439.224 200.867 439.928 202.168C440.632 203.448 440.984 204.92 440.984 206.584L440.952 207.288ZM432.824 199.992C431.202 199.992 429.837 200.515 428.728 201.56C427.64 202.584 427.021 203.928 426.872 205.592H438.808C438.658 203.928 438.029 202.584 436.92 201.56C435.832 200.515 434.466 199.992 432.824 199.992ZM445.608 191.256H447.88V215H445.608V191.256ZM461.082 215.16C459.461 215.16 457.999 214.797 456.698 214.072C455.397 213.325 454.373 212.301 453.626 211C452.879 209.699 452.506 208.227 452.506 206.584C452.506 204.941 452.879 203.469 453.626 202.168C454.373 200.867 455.397 199.853 456.698 199.128C457.999 198.403 459.461 198.04 461.082 198.04C462.703 198.04 464.165 198.403 465.466 199.128C466.767 199.853 467.781 200.867 468.506 202.168C469.253 203.469 469.626 204.941 469.626 206.584C469.626 208.227 469.253 209.699 468.506 211C467.781 212.301 466.767 213.325 465.466 214.072C464.165 214.797 462.703 215.16 461.082 215.16ZM461.082 213.144C462.277 213.144 463.343 212.877 464.282 212.344C465.242 211.789 465.989 211.011 466.522 210.008C467.055 209.005 467.322 207.864 467.322 206.584C467.322 205.304 467.055 204.163 466.522 203.16C465.989 202.157 465.242 201.389 464.282 200.856C463.343 200.301 462.277 200.024 461.082 200.024C459.887 200.024 458.81 200.301 457.85 200.856C456.911 201.389 456.165 202.157 455.61 203.16C455.077 204.163 454.81 205.304 454.81 206.584C454.81 207.864 455.077 209.005 455.61 210.008C456.165 211.011 456.911 211.789 457.85 212.344C458.81 212.877 459.887 213.144 461.082 213.144ZM482.936 198.04C484.515 198.04 485.944 198.403 487.224 199.128C488.504 199.832 489.507 200.835 490.232 202.136C490.958 203.437 491.32 204.92 491.32 206.584C491.32 208.269 490.958 209.763 490.232 211.064C489.507 212.365 488.504 213.379 487.224 214.104C485.966 214.808 484.536 215.16 482.936 215.16C481.571 215.16 480.334 214.883 479.224 214.328C478.136 213.752 477.24 212.92 476.536 211.832V221.208H474.264V198.168H476.44V201.496C477.123 200.387 478.019 199.533 479.128 198.936C480.259 198.339 481.528 198.04 482.936 198.04ZM482.776 213.144C483.95 213.144 485.016 212.877 485.976 212.344C486.936 211.789 487.683 211.011 488.216 210.008C488.771 209.005 489.048 207.864 489.048 206.584C489.048 205.304 488.771 204.173 488.216 203.192C487.683 202.189 486.936 201.411 485.976 200.856C485.016 200.301 483.95 200.024 482.776 200.024C481.582 200.024 480.504 200.301 479.544 200.856C478.606 201.411 477.859 202.189 477.304 203.192C476.771 204.173 476.504 205.304 476.504 206.584C476.504 207.864 476.771 209.005 477.304 210.008C477.859 211.011 478.606 211.789 479.544 212.344C480.504 212.877 481.582 213.144 482.776 213.144ZM510.608 207.288H496.528C496.656 209.037 497.328 210.456 498.544 211.544C499.76 212.611 501.296 213.144 503.152 213.144C504.197 213.144 505.157 212.963 506.032 212.6C506.907 212.216 507.664 211.661 508.304 210.936L509.584 212.408C508.837 213.304 507.899 213.987 506.768 214.456C505.659 214.925 504.432 215.16 503.088 215.16C501.36 215.16 499.824 214.797 498.48 214.072C497.157 213.325 496.123 212.301 495.376 211C494.629 209.699 494.256 208.227 494.256 206.584C494.256 204.941 494.608 203.469 495.312 202.168C496.037 200.867 497.019 199.853 498.256 199.128C499.515 198.403 500.923 198.04 502.48 198.04C504.037 198.04 505.435 198.403 506.672 199.128C507.909 199.853 508.88 200.867 509.584 202.168C510.288 203.448 510.64 204.92 510.64 206.584L510.608 207.288ZM502.48 199.992C500.859 199.992 499.493 200.515 498.384 201.56C497.296 202.584 496.677 203.928 496.528 205.592H508.464C508.315 203.928 507.685 202.584 506.576 201.56C505.488 200.515 504.123 199.992 502.48 199.992ZM517.44 201.464C517.974 200.333 518.763 199.48 519.808 198.904C520.875 198.328 522.187 198.04 523.744 198.04V200.248L523.2 200.216C521.43 200.216 520.043 200.76 519.04 201.848C518.038 202.936 517.536 204.461 517.536 206.424V215H515.264V198.168H517.44V201.464Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.999479,
    height: 4,
    transform: "matrix(-1 0 0 1 638.67 226.622)",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M825.452 71.3004L800.554 47.0392C796.396 42.9869 789.625 42.9869 785.467 47.0392L765.954 66.0535L805.939 105.017L825.451 86.0029C829.61 81.9507 829.61 75.3526 825.452 71.3004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.671 231V192.036L754.652 77.0671L794.637 116.031L676.655 231H636.671ZM657.973 192.365L651.033 199.128L668.078 215.738L675.018 208.975C676.82 207.219 678.054 205.321 678.719 203.28C679.369 201.224 679.434 199.199 678.914 197.206C678.378 195.197 677.283 193.385 675.627 191.772C673.971 190.158 672.12 189.098 670.075 188.592C668.013 188.07 665.935 188.133 663.841 188.782C661.731 189.415 659.775 190.609 657.973 192.365ZM676.406 202.877C675.87 204.538 674.856 206.096 673.362 207.551L668.322 212.463L654.393 198.89L659.434 193.979C660.927 192.523 662.534 191.542 664.255 191.036C665.96 190.514 667.648 190.467 669.32 190.894C670.976 191.305 672.486 192.175 673.849 193.504C675.213 194.833 676.114 196.312 676.552 197.941C676.974 199.555 676.926 201.2 676.406 202.877ZM682.4 190.344L693.115 179.903L692.603 179.358C691.337 178.124 689.949 177.293 688.439 176.866C686.913 176.423 685.404 176.391 683.91 176.771C682.417 177.151 681.077 177.918 679.892 179.073C678.707 180.228 677.912 181.541 677.506 183.012C677.116 184.467 677.141 185.946 677.579 187.449C678.034 188.936 678.886 190.289 680.136 191.507C681.386 192.725 682.79 193.539 684.349 193.951C685.907 194.362 687.474 194.354 689.048 193.927C690.623 193.468 692.068 192.598 693.383 191.317C694.405 190.32 695.16 189.237 695.647 188.066C696.15 186.88 696.345 185.677 696.232 184.459L694.137 184.317C694.202 185.329 694.048 186.302 693.675 187.236C693.285 188.153 692.693 188.999 691.897 189.774C690.485 191.151 688.91 191.894 687.173 192.005C685.42 192.1 683.829 191.546 682.4 190.344ZM679.454 184.72C679.503 183.123 680.144 181.723 681.378 180.52C682.628 179.302 684.064 178.677 685.688 178.646C687.311 178.582 688.813 179.112 690.193 180.236L681.11 189.086C679.957 187.742 679.405 186.286 679.454 184.72ZM702.648 181.433C703.898 180.785 705.043 179.954 706.082 178.942C707.738 177.328 708.703 175.754 708.979 174.22C709.255 172.654 708.833 171.325 707.713 170.234C706.885 169.427 706.017 169.008 705.108 168.976C704.199 168.944 703.338 169.134 702.527 169.545C701.715 169.957 700.7 170.566 699.483 171.372C698.509 172.037 697.721 172.535 697.121 172.867C696.504 173.184 695.887 173.358 695.27 173.389C694.669 173.405 694.126 173.176 693.639 172.701C693.006 172.084 692.77 171.317 692.932 170.4C693.111 169.466 693.752 168.462 694.856 167.386C696.317 165.962 697.941 165.092 699.726 164.776L699.093 162.688C698.2 162.862 697.234 163.249 696.195 163.85C695.14 164.436 694.199 165.132 693.371 165.939C691.78 167.489 690.879 169.031 690.668 170.566C690.457 172.1 690.887 173.389 691.958 174.433C692.819 175.272 693.712 175.715 694.637 175.762C695.579 175.794 696.471 175.604 697.316 175.193C698.143 174.766 699.174 174.141 700.408 173.318C701.317 172.685 702.08 172.211 702.697 171.895C703.298 171.562 703.89 171.38 704.475 171.349C705.043 171.301 705.562 171.507 706.033 171.966C706.699 172.614 706.934 173.397 706.739 174.315C706.544 175.201 705.863 176.213 704.694 177.352C703.817 178.206 702.843 178.902 701.772 179.44C700.684 179.962 699.661 180.279 698.704 180.389L699.288 182.478C700.278 182.398 701.398 182.05 702.648 181.433ZM703.361 156.394L701.632 158.078L714.44 170.56L716.169 168.875L703.361 156.394ZM698.442 155.017C698.929 155.017 699.351 154.843 699.708 154.495C700.065 154.147 700.244 153.736 700.244 153.261C700.244 152.787 700.065 152.375 699.708 152.027C699.383 151.711 698.986 151.561 698.515 151.577C698.028 151.577 697.606 151.751 697.249 152.099C696.892 152.447 696.713 152.858 696.713 153.333C696.713 153.807 696.875 154.203 697.2 154.519C697.541 154.851 697.955 155.017 698.442 155.017ZM731.28 151.113L720.03 140.15L718.374 141.763L720.834 144.16C719.47 143.875 718.131 143.947 716.816 144.374C715.501 144.801 714.3 145.544 713.212 146.604C711.994 147.791 711.158 149.111 710.704 150.567C710.249 152.022 710.209 153.485 710.582 154.957C710.972 156.412 711.767 157.725 712.968 158.896C714.17 160.066 715.525 160.849 717.035 161.245C718.545 161.609 720.054 161.577 721.564 161.15C723.074 160.691 724.429 159.876 725.631 158.706C726.686 157.678 727.433 156.539 727.871 155.289C728.325 154.023 728.415 152.734 728.139 151.421L729.77 153.011C731.361 154.561 732.148 156.072 732.132 157.543C732.132 159.03 731.321 160.565 729.697 162.146C728.723 163.096 727.635 163.855 726.434 164.424C725.249 164.978 724.072 165.287 722.903 165.35L723.342 167.485C724.624 167.438 725.963 167.066 727.36 166.37C728.788 165.674 730.095 164.749 731.28 163.594C733.423 161.506 734.494 159.433 734.494 157.377C734.527 155.32 733.455 153.232 731.28 151.113ZM726.191 154.031C725.834 155.139 725.192 156.143 724.267 157.045C723.342 157.946 722.311 158.571 721.174 158.919C720.038 159.236 718.902 159.252 717.765 158.967C716.645 158.666 715.631 158.073 714.722 157.187C713.813 156.301 713.204 155.313 712.895 154.221C712.603 153.114 712.627 152.014 712.968 150.923C713.325 149.815 713.967 148.811 714.892 147.909C715.834 146.992 716.873 146.375 718.009 146.058C719.145 145.71 720.274 145.687 721.394 145.987C722.514 146.256 723.528 146.834 724.437 147.719C725.347 148.605 725.947 149.602 726.239 150.709C726.548 151.801 726.532 152.908 726.191 154.031ZM736.529 126.635C734.646 126.635 732.9 127.418 731.293 128.984C730.189 130.06 729.434 131.223 729.029 132.473C728.623 133.691 728.574 134.909 728.883 136.127L726.521 133.825L724.865 135.439L737.673 147.92L739.402 146.235L732.681 139.686C731.236 138.278 730.506 136.791 730.49 135.225C730.473 133.627 731.155 132.156 732.535 130.812C733.769 129.609 735.068 129.024 736.431 129.056C737.795 129.087 739.142 129.752 740.473 131.049L747.73 138.12L749.459 136.435L742.032 129.198C740.246 127.458 738.412 126.604 736.529 126.635ZM748.77 125.669L759.484 115.229L758.973 114.683C757.707 113.449 756.319 112.618 754.809 112.191C753.283 111.748 751.773 111.717 750.28 112.096C748.786 112.476 747.447 113.243 746.262 114.398C745.077 115.553 744.281 116.866 743.875 118.337C743.486 119.792 743.51 121.272 743.948 122.774C744.403 124.261 745.255 125.614 746.505 126.832C747.755 128.05 749.159 128.865 750.718 129.276C752.276 129.687 753.843 129.679 755.418 129.252C756.992 128.794 758.437 127.923 759.752 126.642C760.775 125.646 761.53 124.562 762.017 123.391C762.52 122.205 762.715 121.003 762.601 119.785L760.507 119.642C760.572 120.655 760.418 121.627 760.044 122.561C759.655 123.478 759.062 124.325 758.267 125.1C756.854 126.476 755.28 127.22 753.543 127.33C751.789 127.425 750.198 126.872 748.77 125.669ZM745.823 120.046C745.872 118.448 746.513 117.048 747.747 115.846C748.997 114.627 750.434 114.003 752.057 113.971C753.681 113.908 755.182 114.438 756.562 115.561L747.479 124.412C746.327 123.067 745.775 121.612 745.823 120.046ZM760.105 102.189C759.748 103.392 759.797 104.61 760.252 105.844L757.743 103.399L756.088 105.013L768.896 117.494L770.625 115.81L764.099 109.45C762.605 107.995 761.826 106.492 761.761 104.942C761.696 103.392 762.338 101.96 763.685 100.647L764.123 100.267L762.443 98.63C761.258 99.7848 760.479 100.971 760.105 102.189Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358 231H676.885L674.835 233H358V231Z",
    fill: "#FF4D5A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 240.873,
    y: 49,
    width: 9.00082,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 220.392,
    y: 47.9468,
    width: 30.5542,
    height: 184.604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 220.392,
    y: 56.6001,
    width: 10.6987,
    height: 171.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 0,
    y: 39.9998,
    width: 228.768,
    height: 195.206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6074,
    fill: "white",
    transform: "translate(225.853 220.289) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 195.545) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 170.801) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 121.313) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 71.825) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 146.057) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.744,
    height: 18.6075,
    fill: "white",
    transform: "translate(225.853 96.5691) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265.862,
    height: 266,
    fill: "white",
    transform: "translate(311.841)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.9,
    height: 187,
    fill: "white",
    transform: "translate(636.671 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicDeveloperDesigner);
export default __webpack_public_path__ + "static/media/music-developer-designer.3c4ec9532bf9067430a579f8b2dcf254.svg";
export { ForwardRef as ReactComponent };